export const clearCacheApiHandler = {
  method: "POST",
  path: () => `cache/clear`
};